module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "add_element_in_view",
    class: {
      'is-close': _vm.compIsClose
    },
    on: {
      "click": _vm.emitOnClick
    }
  }, [_c('img', {
    attrs: {
      "src": "/images/add-accent.svg"
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9f18eb1c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./app/components/elements/PlusBtn.vue
// module id = 657
// module chunks = 0